import { isSessionRound } from 'common-data-handling';
import { useEventSchedule } from '../useEventSchedule';
import { useMemo } from 'react';
import { uniqBy } from 'lodash';

/**
 * Given an array of sessions, returns the parent rounds (if any) as an array.
 * @param {number} eventId - The ID of the event.
 * @param {array} sessions - The array of sessions.
 * @returns {array} Array of parent rounds.
 */
export function useParentRounds(eventId, sessions) {
    const allRounds = useEventSchedule(eventId, {
            filter: isSessionRound,
        }),
        rounds = useMemo(
            () =>
                uniqBy(
                    sessions
                        .filter((s) => !!s.round_id)
                        .map((s) => allRounds.find((r) => r.id == s.round_id))
                        .filter(Boolean),
                    'id'
                ),
            [ sessions, allRounds ]
        );
    return rounds;
}
